module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n    .geo-sys-requirements {\n        position   : absolute;\n        top        : 0;\n        left       : 100px;\n        z-index    : 9999;\n        background : #fff;\n        box-shadow : 1px 2px 6px 0 rgba(0, 0, 0, 0.25);\n        width      : 500px;\n    }\n\n    .geo-sys-requirements .closer {\n        position : absolute;\n        top      : 2px;\n        right    : 2px;\n        cursor   : pointer;\n    }\n\n    .geo-sys-requirements > div {\n        margin : 5px 0;\n    }\n\n    .geo-sys-requirements .table > div {\n        background : #F8F8F8;\n    }\n\n    .geo-sys-requirements .table > div:nth-child(2n + 1) {\n        background : #fff;\n    }\n\n    .geo-sys-requirements .table > div > div {\n        padding : 3px;\n    }\n\n    .geo-sys-requirements .table > div > div:first-child {\n        width : 30%;\n    }\n</style>\n<div class=\"geo-sys-requirements padding__ltrb-10\">\n    <div class=\"align-center\">\n        Версия <span class=\"title\">")
    ; __append(escapeFn( version ))
    ; __append("</span>\n    </div>\n    <div class=\"align-center\">\n        <span class=\"title\">Системные требования</span>\n    </div>\n    <div class=\"table w100\">\n        <div>\n            <div class=\"title\">Процессор</div>\n            <div>Intel(R) Core(TM) i3, 1.5 GHz</div>\n        </div>\n        <div>\n            <div class=\"title\">RAM</div>\n            <div>не менее 4 GB</div>\n        </div>\n        <div>\n            <div class=\"title\">Браузер</div>\n            <div>Google Chrome / Mozilla Firefox / Internet Explorer / Safari последних версий</div>\n        </div>\n    </div>\n    <span name=\"close\" class=\"icon-close icon-12 closer\"></span>\n</div>\n")
  }
  return __output.join("");

}